import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Products from "../components/Products";
import "../styles/Home.css"; 

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <About />
      <Products />
    </div>
  );
};

export default Home;